export class LotNoteType {
    isEditMode: boolean;
    isPublic: boolean;
    isInternal: boolean;
    targetAudience: any;
}
